import { LngLat } from "react-map-gl/maplibre";

import { ScenarioLayer } from "@nens/rana/api-v1";

import { useLizardScenarioPointDataQuery } from "@/queries/query-lizard-point-data";

import { PopupContent } from "./popup-content";

interface PopupScenarioInfoProps {
  descriptorId: string;
  layers: ScenarioLayer[];
  point: LngLat | null;
}

export function PopupScenarioInfo({ descriptorId, layers, point }: PopupScenarioInfoProps) {
  const layerIds = layers.map((layer) => layer.id + "");

  const pointDataQueries = useLizardScenarioPointDataQuery(descriptorId, layerIds, point);

  if (!point || layers.length === 0 || layerIds.some((layerId) => !layerId)) return null;

  return (
    <PopupContent>
      {layers.map(({ name, label }, i) => {
        const { data, isLoading, isError } = pointDataQueries[i];
        const value = data?.results[0]?.value ?? null;
        const unit = label ?? "";
        const valueWithUnit = value !== null ? `${+value.toFixed(3)} ${unit}` : undefined;

        return (
          <PopupContent.Item
            key={label}
            label={name}
            value={valueWithUnit}
            {...{ isLoading, isError }}
          />
        );
      })}
    </PopupContent>
  );
}
